<template>
  <div>
        <v-layout wrap align-center justify-center class="px-2">
            <!-- Login With Google -->
            <v-flex xs12>
                <SocialLogin @onSuccess="onSuccessfullLogin"></SocialLogin>
            </v-flex>
            <div class="pt-1 secondary--text">{{$t('label.or')}}</div>
            <v-flex v-if="!useEmail" xs12 text-xs-center class="my-3">
                <v-btn @click="useEmail = true" flat small color="#4286f5" class="py-3 px-4 login-with-email-text subheading">{{ $t('screener.login_with_email.title')}}</v-btn>
            </v-flex>
            <v-flex xs12 v-if="useEmail" class="my-4">
                <v-form ref="emailForm" onsubmit="return false;">
                    <v-text-field
                        outline
                        id="email"
                        color="secondary"
                        background-color='secondary'
                        :label="$t('enrollment.steps.login.component.title')"
                        name="email"
                        placeholder="example@mail.com"
                        :rules="[rules.required, rules.email]"
                        prepend-inner-icon="email"
                        type="text"
                        v-model="email"
                        width="50%"
                    ></v-text-field>
                </v-form>
            </v-flex>
        </v-layout>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                :class="[$vuetify.rtl ? 'ml-2' : '']"
                color="green white--text"
                @click.stop="onCancel"
                >{{ $t(`${eventPrefix}.btn.cancel`) }}</v-btn
            >
            <v-btn
                :disabled="!useEmail"
                :class="[$vuetify.rtl ? 'mx-0' : '']"
                color="green white--text"
                @click.prevent="onConfirm"
                >{{ $t("enrollment.steps.continue.button") }}</v-btn
            >
        </v-card-actions>
  </div>
</template>

<script>
import rules from "@/validation";
import SocialLogin from "@/components/auth/SocialLogin"

export default {
    name:"EnrollmentAskEmail",
    props:{
        eventPrefix: {
            type: String,
            default: 'screener'
        }
    },
    data(){
        return{
            rules,
            email:null,
            useEmail:false
        }
    },
    components: {
        SocialLogin
    },
    watch:{
        email(){
            this.$emit("update:email",this.email);
        }
    },
    methods:{
        onCancel(){
            this.$emit("onCancel",{});
        },
        onConfirm(){
            this.$emit("onConfirm",{});
        },
        validate(){
            return this.$refs.emailForm.validate();
        },
        onSuccessfullLogin(response){
            this.$emit('loginWithFirebase',response)
        }
    }
}
</script>

<style scoped>
    >>> .v-text-field__slot input {
      color: var(--v-secondary-base) !important
    }
    >>> .v-icon {
        color: var(--v-secondary-base) !important
    }
    >>> .v-input__slot .v-label {
        color: var(--v-secondary-base) !important
    }
.login-with-email-text{
    text-transform: initial;
    letter-spacing: 0.03em; 
}
</style>
